export const smartlookIdentify = () => {
  try {
    if (window.smartlook) {
      const alefUser = localStorage.getItem('alef_user');
      // The `user` should always have value.
      // But if there is a case where this method was called without the user,
      // we can't just throw an error and not allow user to proceed.
      // Instead we will just use NOT_AVAILABLE as user id in order for us to track these cases
      // and see the recordings in smartlook dashboard on why is it happening.
      const user = alefUser
        ? JSON.parse(alefUser).user
        : { uuid: 'NOT_AVAILABLE' };

      const {
        username,
        tenant,
        school,
        uuid,
        onboarded,
        enabled,
        role,
        avatar,
      } = user;

      window.smartlook('identify', uuid, {
        username,
        tenant,
        schoolId: school && school.uuid,
        onboarded,
        enabled,
        role,
        avatar,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error identifying user in smartlook :', err);
  }
};
